export class Answer {
    
       id: string;
       response_id: string;
       question_number: number;
       answer_history: string;
       answer_value:string;
       answer_text:any;
       time_taken:string;
       answer_text_id:number;
       
    //    constructor(public question_number: number,public answer_value: string){
    //    }

    //    constructor(public question_number: number,public answer_text: string){
    // }
     
    }


// WEBPACK FOOTER //
// ./src/models/answer.ts